import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useEffect, useRef, useState, useMemo } from 'react';

//DE
import legendForestCondition_DE from '../../Images/Legends/Legends_de/Legend_Vitality.png';
import legendWaterStress_DE from '../../Images/Legends/Legends_de/Legend_WaterStress.png';
import legendSpecies_DE from '../../Images/Legends/Legends_de/Legend_Species.png';
import legendFire_DE from '../../Images/Legends/Legends_de/Legend_Fire.png';
import legendDamagedAreas_DE from '../../Images/Legends/Legends_de/Legend_DamagedAreas.png';

//EN
import legendForestCondition_EN from '../../Images/Legends/Legends_en/Legend_Vitality.png';
import legendWaterStress_EN from '../../Images/Legends/Legends_en/Legend_WaterStress.png';
import legendSpecies_EN from '../../Images/Legends/Legends_en/Legend_Species.png';
import legendFire_EN from '../../Images/Legends/Legends_en/Legend_Fire.png';

import { useLanguage } from '../../Language/LanguageContext';



export default function LegendSimple(props: any) {
    const { language } = useLanguage();

    let subDrawerAlreadyOpened = useRef(false)
    const useDidMountEffect = (func: any, deps: any) => {
        // Prevents re-render on inital load
        const didMount = useRef(false);
        useEffect(() => {
            if (didMount.current) func();
            else didMount.current = true;
        }, deps);
    }

    // Bundesland change
    useDidMountEffect(() => {
        subDrawerAlreadyOpened.current = true;
        // setSubDrawerAlreadyOpened(true)
    }, [props.leftSubDrawerOpen])


    var legendImage = null;
    console.log("Layer", props.activeLayer)

    switch (props.activeLayer) {

        case "laubwaldWasserTrend":
            legendImage = language === 'de' ? legendWaterStress_DE : legendWaterStress_EN;
            break;
        case "baumarten":
            legendImage = language === 'de' ? legendSpecies_DE : legendSpecies_EN;
            break;

        case "schaden":
            legendImage = legendDamagedAreas_DE;
            break;
        case "fire":
            legendImage = language === 'de' ? legendFire_DE : legendFire_EN;
            break;
        default:
            legendImage = language === 'de' ? legendForestCondition_DE : legendForestCondition_EN;
            break;
    }

    const legendContent = (

        <Box
            component="img"
            sx={{
                // m: 1,
                // width: "70vw",
                p: 1,
                width: "100%",


            }}
            src={legendImage}
        />

    )

    return (
        <>
            {props.mobile ?
                <LegendMobile
                    {...props}>
                    {legendContent}
                </LegendMobile>
                :
                <LegendDesktop
                    {...props}>
                    {legendContent}
                </LegendDesktop>
            }

        </>


    )

}

function LegendDesktop(props: any) {
    return (
        <Box
            sx={{
                position: 'absolute',
                display: 'flex',
                zIndex: 1000,
                m: 2,
                left: "50%",
                ...(props.activeLayer === 'baumarten' ? {

                    ml: "15px", // (drawerWidth/2)- (width/2)  
                    width: "320px"

                } :
                    {
                        ml: "-55px", //(drawerWidth/2)- (width/2)
                        width: "460px"
                    }
                ),
            }}
        >
            <Paper elevation={3}>
                {props.children}
            </Paper>
        </Box >
    );
}

function LegendMobile(props: any) {
    const handleLegendClick = () => {
        props.setLeftSubDrawerOpen(!props.leftSubDrawerOpen)
        // props.setLeftSubDrawerType("BAUMARTEN")
    }
    return (
        <Box
            onClick={() => handleLegendClick()}
            sx={{
                position: 'relative',
                zIndex: 1000,
                // bottom: 100,
                ...(props.activeLayer === 'baumarten' ? {

                    width: "100%"

                } :
                    {
                        width: "100%"
                    }
                ),
            }}
        >
            <Paper elevation={3} square={true}>
                {props.children}
            </Paper>
        </Box >
    );
}